// src/components/ErrorBoundary.js
import React from 'react';
import { AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center px-4"
          data-testid="error-boundary"
        >
          <div className="text-center">
            <div className="w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto mb-5">
              <AlertTriangle size={32} className="text-red-500" />
            </div>
            <h1 className="text-2xl font-bold mb-2 dark:text-gray-100">
              {this.props.title || "Quelque chose s'est mal passé"}
            </h1>
            <p className="text-gray-500 dark:text-gray-400 mb-6 max-w-sm mx-auto">
              {this.props.desc ||
                'Une erreur inattendue est survenue. Rechargez la page pour continuer.'}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2.5 bg-rose-500 text-white rounded-full font-semibold hover:bg-rose-600 transition"
              data-testid="error-boundary-reload"
            >
              {this.props.reloadLabel || 'Recharger la page'}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
